import { useRouteError } from 'react-router-dom'

export default function RouterErrorBoundary() {
  const error = useRouteError()


  return (
    <div className="p-6 max-w-xl mx-auto bg-red-50 border border-red-200 rounded-lg shadow">
      <h2 className="text-lg font-semibold text-red-600">Something went wrong.</h2>

      <p className="mt-2 text-red-700 font-medium">Error Message:</p>
      <pre className="whitespace-pre-wrap text-sm text-red-800 bg-red-100 p-2 rounded">
        {error?.message || error?.toString()}
      </pre>

      {error?.stack && (
        <>
          <p className="mt-2 text-red-700 font-medium">Stack Trace:</p>
          <pre className="whitespace-pre-wrap text-xs text-red-700 bg-red-100 p-2 rounded">
            {error.stack}
          </pre>
        </>
      )}
    </div>
  )
}
